import React, { Component } from 'react'
import { connect } from "react-redux"
import { ls } from "../../../locale"
import { Button } from "react-bootstrap"
import { getLastFlightDate } from "../../CheckoutPage/helper"

import { commonHelpers, getAgentPath, history, isInAppBrowser } from "../../../helpers"

import { bookingActions } from "../../../state/ducks/booking"
import { mmbActions } from "../../../state/ducks/mmb"
import { resourceActions } from "../../../state/ducks/resources"
import { sessionActions } from "../../../state/ducks/session";

import Header from "../../../components/Header"
import Footer from "../../../components/Footer"

import Contact from "../../CheckoutPage/Contact"
import Passengers from "../../CheckoutPage/Passengers"
import "../../CheckoutPage/index.scss"
import "./index.scss"
import Backdrop from '../../../components/Backdrop'
import { DialogBox } from '../../../comps/dialog'

export class ContactPage extends Component {

  constructor(props) {
    super(props);

    let userData = props.getUserData();
    if(!userData || !userData.loggedIn) userData = null;

    this.state = {
      contactChanged: false,
      userData,
      isShowDialogBox: false,
      dialogMessages: [],
    };
  }

  componentDidMount() {
    this.props.getCountries().then(() => {
      this.props.getBookingWithSummary();
      this.props.getAncillaries();
    });
  }


  continue = () => {
    if(!this.state.passengerChanged && !this.state.contactChanged) {
      this.goBack();
      return;
    }

    if(!this.contactComponent.validateForm()) return;

    if(this.passengersComponent) {
      const isPassengersValid = this.passengersComponent.validateForm();
      if(!isPassengersValid) return;
    }
    const contactData = this.contactComponent ? this.contactComponent.getFormValues() : undefined;
    const passengerData = this.passengersComponent ? this.passengersComponent.getFormValues() : undefined;

    const data = {
      contact: contactData,
      passengers: passengerData
    }

    this.props.updateContact(data).then((response) => {
      this.setState({
        contactChanged: false,
        passengerChanged: false
      })

      if(response.additionalMessages?.length > 0) {
        this.props.getBooking();
        this.showDialogBox(response.additionalMessages);
        return;
      }
      else {
        this.goBack();
      }
    })
  }

  goBack = () => {
    const nextPage = getAgentPath() + "/mmb/summary";
    history.push("/" + ls.lang + nextPage);
  }

  onContactChanged = () => {
    this.setState({
      contactChanged: true
    })
  }

  onPassengerChanged = () => {
    this.setState({
      passengerChanged: true
    })
  }

  showDialogBox = (messages) => {
    this.setState({
      isShowDialogBox: true,
      dialogMessages: messages ?? []
    })
  }

  hideDialogBox = () => {
    this.setState({
      isShowDialogBox: false,
      dialogMessages: []
    })
  }

  handleWhatsAppChanged = (checked) => {
    if(checked) {
      return this.props.addWhatsApp().then(() => {
        return this.props.getBookingWithSummary();
      })
    }
    else {
      return this.props.removeWhatsApp().then(() => {
        return this.props.getBookingWithSummary();
      })
    }
  }

  render() {

    const rButton = ls.t('Button');
    if(!rButton.Confirm) return null;

    const inAppBrowser = isInAppBrowser();
    const { countries, booking } = this.props;

    const contact = (booking && booking.contact) || {};
    
    const canChangePassenger = booking && Array.isArray(booking.segments) && 
      booking.segments.some(x => x && x.permissions && x.permissions.canChangePassenger);
    const passengers = booking && Array.isArray(booking.passengers) ? booking.passengers : [];

    let flightDate = getLastFlightDate(booking);
    if (!flightDate) flightDate = new Date();

    const userData = this.state.userData;

    return (
      <div className={ls.t("rootClass") + " main-container"} dir={ls.t("direction")}>
        <div className="header-con">
          <Header hasSummary={true} />
        </div>
        <Backdrop />
        <div className="container passenger summary-contact padt20 padb40">
          <div className="min-height">

            {canChangePassenger && <Passengers
              ref={(element) => (this.passengersComponent = element)}
              key={commonHelpers.getHashCode(passengers)}
              passengers={passengers}
              flightDate={flightDate}
              userData={userData}
              onStateChanged={this.onPassengerChanged}
            />}

            <Contact
              ref={(element) => (this.contactComponent = element)}
              key={commonHelpers.getHashCode(contact)}
              contact={contact}
              currencyCode={booking?.currencyCode ?? 'OMR'}
              countries={countries}
              ancillaries={this.props.ancillaries}
              passengers={passengers}
              onStateChanged={this.onContactChanged}
              onWhatsAppChanged={this.handleWhatsAppChanged}
              bookingMode={booking?.bookingMode}
            />

            <div className="clearfix btnCon">
              {!inAppBrowser && <Button type="submit" className="btn btn-primary pull-left flip btn-cancel btn-effect"
                onClick={() => this.goBack()}>
                <span><i className="picon picon-btn-arrow-left-w" />{rButton.Back}</span>
              </Button>}
              <Button type="submit" className="btn btn-primary pull-right flip btn-submit btn-effect"
                onClick={() => this.continue()}><span>{rButton.Confirm}
                  <i className="picon picon-btn-arrow-right-w" /></span>
              </Button>
            </div>
          </div>
        </div>
        {!inAppBrowser && <Footer />}
        <DialogBox open={this.state.isShowDialogBox}  onClose={() => this.hideDialogBox()} hideCancelButton={true}>
          {this.state.dialogMessages?.map((message, index) => (<p key={index}>{message}</p>))}
        </DialogBox>
      </div>
    )
  }

}

function mapStateToProps(state) {
  return {
    booking: state.booking.details,
    ancillaries: state.booking.ancillaries,
    countries: state.resources.countries,
  };
}

const mapDispatchToProps = {
  getBookingWithSummary: bookingActions.getBookingWithSummary,
  getBooking: bookingActions.getBooking,
  getAncillaries: bookingActions.getAncillaries,
  addWhatsApp: bookingActions.addWhatsApp,
  removeWhatsApp: bookingActions.removeWhatsApp,
  getCountries: resourceActions.getCountries,
  ...mmbActions,
  getUserData: sessionActions.getUserData,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactPage)
